import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import ProtectedRoute from 'components/routes/ProtectedRoute';
import Tran from 'components/tran/Tran';
import Profile from 'components/auth/Profile';
import Account from 'components/account/Account';
import AccountInfo from 'components/account/AccountInfo';
import { getTokenExpiry } from 'components/utils/Session';
import Footer from 'components/layout/Footer';
import NavBar from 'components/layout/NavBar';
import SideBar from 'components/layout/Sidebar';
import './App.css';
import AdminPanel from 'components/admin/AdminPanel';
import AuthorizedRoute from 'components/routes/AuthorizedRoute';
import Subscriber from 'components/subscriber/Subscriber';
import mapDispatchToProps from 'reducers/actions/dispatchProps';
import mapStateToProps from 'reducers/actions/stateToProps';
import { connect } from 'react-redux';
import Dashboard from 'components/dashboard';
import Redirect from 'components/layout/Redirect';
import Members from 'components/account/Members';
import Statements from 'components/account/Statements';
import Manage from 'components/account/Manage';
import Constants from 'components/utils/constants';
// import { AccountHandler } from 'chits-data/dist';
let console = Constants.consoleWrapper(false);
const Page404 = () => (
  <div>
  <h1>The page you are looking is not found.</h1>
  <p>Please click here to go back to <a href="/"><strong>Home</strong></a> page</p>
  </div>
);

class App extends Component {

  constructor(props) {
    super(props)
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);

    // this._handler = new AccountHandler();
    this.extractURLParameters();
  }
  
  extractURLParameters() {
    console.debug('extractURLParameters()')
    let _clearCacheRequest = false;
		try {
      // https://nodejs.org/api/url.html#class-urlsearchparams
			let qParams = new URLSearchParams(window.location.search);
			console.debug("App -> Query params in the request:" + qParams.toString())
			if (qParams.has('refresh')) {
				// set state 
				_clearCacheRequest = true;
				// prepare url to remove all query params
          let newUrl = window.location.href.split('?')[0];
          // // Seems this does not have any effect
          let newPageTitle = "Chitfund Transactions";
          // // update URL so that this code execute only once.
          window.history.replaceState(null, newPageTitle, newUrl);
        // (or)
        // qParams.delete('refresh');
			}
		} catch (error) {
			console.error(error)
		}

    if (_clearCacheRequest) {
      this.props.setClearCache(true);
    }
	}

  render() {
    return (
      <div className="wrapper">
        <SideBar />
        <div className="main-panel">
          <NavBar 
            sessionExpiry={getTokenExpiry()}/>
          <div className="content">
            {this.renderRouter()}
          </div>
          <Footer />
        </div>
      </div>
    )
  }

  updateWindowDimensions() {
    this.props.setScreenWidth(window.innerWidth);
    this.props.setViewPort(window.innerWidth <= 420 ? 'small' : 'other')
    this.props.setPlatForm(window.isAndroid() ? 'android' : 'web')
  }

  componentDidMount() {
      // Capture screen diementsions once
      this.updateWindowDimensions();
      // register a 'resize' event to capture the window dimentions dynamically
      window.addEventListener('resize', this.updateWindowDimensions);
      // extract parameters from URL including query params


      // //TODO: Move below block to redirect component
      // let ac = this._handler.getActiveAccount();
      // // asynchronously load account information to props
      // this._handler.getAccountCached(ac).then((account)=>{
      //     if (account) {
      //         console.debug('seeting current account', account);
      //         this.props.setCurrentAccount(account);
      //     } else {
      //         console.debug('current account NOT READY yet');
      //     }
      // })
  }
    
  componentWillUnmount() {
      window.removeEventListener('resize', this.updateWindowDimensions);
  }
  renderRouter() {
    return (
        <Switch>
          {/* <ProtectedRoute exact path="/dashboard" component={dashboard} /> */}
          <ProtectedRoute exact path="/redirect/account/:accountId/page/:pageId" component={Redirect} />
          <ProtectedRoute exact path="/redirect/account/:accountId" component={Redirect} />
          <ProtectedRoute exact path="/info" component={AccountInfo} />
          {/* <ProtectedRoute exact path="/accounts/ac/:pageId" component={AccountInfo} /> */}
          {/* <ProtectedRoute exact path="/accounts/ac" component={AccountInfo} /> */}
          <ProtectedRoute exact path="/members" component={Members} />
          <ProtectedRoute exact path="/statements" component={Statements} />
          <ProtectedRoute exact path="/accounts" component={Account} />
          <ProtectedRoute exact path="/contacts" component={Subscriber} />
          <ProtectedRoute exact path="/manage" component={Manage} />
          <ProtectedRoute exact path="/transactions/ac/:accountId/link/:linkId" component={Tran} />
          <ProtectedRoute exact path="/transactions/ac/:accountId" component={Tran} />
          <ProtectedRoute exact path="/transactions/:accountId" component={Tran} />
          <ProtectedRoute exact path="/transactions" component={Tran} />
          <ProtectedRoute exact path="/payments" component={Dashboard} />
          <ProtectedRoute exact path="/profile" component={Profile} />
          <AuthorizedRoute exact path="/admin" component={AdminPanel} />
          <Route component={Page404} />
      </Switch>
    );
  }
}
  
export default connect(mapStateToProps, mapDispatchToProps)(App);
